import { BASE_BE_URL } from "../../lib/sessionClient";

export const PHONE_VERIFY = BASE_BE_URL + "/user/phone/verify/";
export const PHONE_UNVERIFY = BASE_BE_URL + "/user/phone/unverify/";
export const BULK_PHONE_VERIFY = BASE_BE_URL + "/user/phone/verify/bulk";
export const BULK_PHONE_UNVERIFY = BASE_BE_URL + "/user/phone/unverify/bulk";

export const UPDATE_USER_ROLE = BASE_BE_URL + "/user/update/role";
export const UPDATE_USER_ROLE_SETUP = BASE_BE_URL + "/user/update/role/setup";
export const ALL_USER = BASE_BE_URL + "/user/all";
export const USER_DISABLE_LIST = BASE_BE_URL + "/user/alldisabled";
export const ALL_OFFICER = BASE_BE_URL + "/officer/all";
export const ADD_USER = BASE_BE_URL + "/user";
export const UPDATE_USER = BASE_BE_URL + "/user/";
export const USER_SETUP = BASE_BE_URL + "/user/setup";
export const OFFICER_SETUP = BASE_BE_URL + "/officer/setup";
export const ADD_OFFICER = BASE_BE_URL + "/officer";
export const UPDATE_USER_ADMINS_SETUP = BASE_BE_URL + "/user/update/admins/setup";
export const UPDATE_USER_ADMINS = BASE_BE_URL + "/user/update/admins";
export const DISABLE_USER = BASE_BE_URL + "/user/disable/";
export const DISABLE_USER_BULK = BASE_BE_URL + "/user/disable/bulk";
export const ENABLE_USER_BULK = BASE_BE_URL + "/user/enable/bulk";
export const ENABLE_USER = BASE_BE_URL + "/user/enable/";
export const GET_USER_ROLES = BASE_BE_URL + "/user/roles/";
export const ACCESS_TOKEN_LOGS = BASE_BE_URL + "/user/accessTokenLogs/"
export const REFRESH_TOKEN_LOGS = BASE_BE_URL + "/user/refreshTokenLogs/"
export const UPDATE_SALARIES = BASE_BE_URL + "/user/update-bulk-salaries"
export const UPDATE_BULK_SALARIES_TEMPLATE = BASE_BE_URL + "/user/update-bulk-salaries-template"
export const DOWNLOAD_BULK_USER_TEMPLATE = BASE_BE_URL + "/user/update-bulk-employment-details-template"
export const UPDATE_BULK_USER = BASE_BE_URL + "/user/update-bulk-employment-details"